import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ChakraProvider} from '@chakra-ui/react'
import './index.css'
import App from './App.jsx'
import theme from './theme'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </StrictMode>,
)
